import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import ProfileContext from "./ProfileContext";
import useUsers from "../../hooks/useUsers";
import AppContext from "../../AppContext";
import List, { STATE } from "../List";
import ChatSessionContext from "../../contexts/ChatSessionContext";
import { ReactComponent as MessageSvg } from "../../assets/profile/message.svg";
const assetsUri = import.meta.env.ASSETS_URI;

const columns = [
  {
    display: "Name",
    key: "user",
    textAlign: "left",
  },
  {
    display: "",
    key: "actions",
    textAlign: "left",
    maxWidth: 200,
  },
];

const Followings = (props) => {
  const {
    user: loggedInUser,
    plans,
    viewProfile,
    viewCompany,
  } = useContext(AppContext);
  const { startChat } = useContext(ChatSessionContext);
  const { isCompany, user, company, isOwner } = useContext(ProfileContext);
  const { queryUsers, querySubscriptions, patchSubscription, queryCompanies } =
    useUsers();
  const [followers, setFollowers] = useState(undefined);
  const [dataState, setDataState] = useState(STATE.LOADING);

  useEffect(() => {
    fetchData();
  }, [user, company, isCompany]);

  const fetchData = async () => {
    const _filter = {
      deleted: false,
      active: true,
    };

    if (isCompany) {
      _filter.company = company._id;
    }

    if (!isCompany) {
      _filter.createdBy = user._id;
    }

    const { data } = await querySubscriptions(_filter, null, -1, {
      subscribes: 1,
    });

    let userIds = [];

    for (const d of data) {
      userIds.push(d.subscribes);
    }

    const { data: users } = await queryUsers(
      {
        _id: {
          $in: userIds,
        },
      },
      null,
      -1,
      { avatar: 1, firstname: 1, surname: 1, plan: 1 }
    );

    const { data: companies } = await queryCompanies(
      {
        _id: {
          $in: userIds,
        },
      },
      null,
      -1,
      { logo: 1, name: 1, enterprise: 1 }
    );

    // * Map users

    let _followers = data.map((d) => {
      const userFound = users.find((u) => u._id === d.subscribes);
      const companyFound = companies.find((u) => u._id === d.subscribes);

      if (!userFound && !companyFound) {
        return null;
      }

      let _ = {
        _id: d._id,
        avatar: null,
        name: "-",
        plan: "-",
        userId: d.subscribes,
      };

      if (userFound) {
        // * Get plan
        const planFound = plans.find((p) => p._id === userFound.plan);

        _ = {
          _id: d._id,
          avatar: userFound.avatar,
          name: `${userFound.firstname} ${userFound.surname || ""}`,
          plan: planFound.name,
          userId: d.subscribes,
          isCompany: false,
        };
      }

      if (companyFound) {
        _ = {
          _id: d._id,
          avatar: companyFound.logo,
          name: companyFound.name,
          plan: companyFound.enterprise ? "Enterprise" : "Business",
          userId: d.subscribes,
          isCompany: true,
        };
      }

      const { avatar, name, plan, userId, isCompany } = _;

      return {
        userId,
        isCompany,
        user: (
          <div className="profile-followers-list-user">
            <img
              className="profile-followers-list-user__avatar"
              alt="follower-avatar"
              src={`${assetsUri}/${avatar}`}
              onError={({ target }) => {
                target.src = avatar;
              }}
            />
            <div className="profile-followers-list-user__name">{name}</div>
            <div className="profile-followers-list-user__plan">{plan}</div>
          </div>
        ),
        actions: (
          <div className="profile-followers-list-user-actions">
            {userId !== loggedInUser?._id && (
              <span
                className="profile-followers-list-user-actions__item"
                onClick={(e) => {
                  e.stopPropagation();
                  startChat(userId, loggedInUser);
                }}
              >
                <MessageSvg height={22} />
                Chat
              </span>
            )}
          </div>
        ),
      };
    });

    setFollowers(_followers.filter((f) => !!f));
    setDataState(STATE.IDLE);
  };

  const handleUserClick = (e) => {
    if (e.isCompany) {
      viewCompany(e.userId);
      return;
    }

    viewProfile(e.userId);
  };

  return (
    <div className="profile-followers">
      <List
        className="profile-followers-list"
        contentState={dataState}
        columns={columns}
        dataSource={followers}
        viewable={true}
        onRecordClick={handleUserClick}
      />
    </div>
  );
};

Followings.propTypes = {};

export default Followings;
